import { ACTIONS } from "../../Models/ENUM";
import LOG from "../../UTIL/LOG";
import CONQUER from "../CONQUER";
import Snappy from "./Snappy";

class AvatarInstance
{
    private conquer     : CONQUER;
    public avatarID     : any;
    public firstName    : any = "";
    public lastName     : any = "";
    public userPhoto    : string = "User.png";
    public bio          : string = '';
    public Snappy       : Snappy;
    public isBot        : boolean = false;
    public vars         : any = {};
    public type         : string = "";
    public name         : String = "Player";
    public fullName     : String = "Plater";
    public following    : number = 0;
    public username     : String = "";

    constructor( conquer:CONQUER, vars:any )
    {
        this.conquer        = conquer;

        this.fill( vars );

        this.Snappy         = new Snappy( conquer, this );
    };

    private fill( vars:any )
    {
        if( vars.firstName && vars.firstName.includes("_GUEST") ) vars.firstName = "GUEST";

        this.avatarID       = vars._id || vars.avatarID || this.avatarID;
        this.name           = vars.name || this.name;
        this.firstName      = this.name.split(" ")[0];
        this.lastName       = this.name.split(" ")[1] || this.lastName;
        this.userPhoto      = vars.userPhoto || this.userPhoto;
        this.isBot          = vars.isBot || false;
        this.type           = vars.type || "";
        this.bio            = vars.bio || this.bio;
        this.username       = vars.username || this.username;
        
        this.fullName       = vars.name;
        this.following      = vars.following || 0;

       // LOG.log("Avatar!", this.firstName, vars.name ); 
 
        this.resetVars();
    }

    public async set() : Promise<any>
    {
        let membership      = await this.conquer.Friends.set( this.avatarID ); 
        return Promise.resolve( membership );
    }

    public resetVars()
    {
        let vars        = this.vars;

        vars.x          = 0;
        vars.y          = 0;
        vars.z          = 0;
        vars.firstName  = this.firstName;
        vars.userPhoto  = this.userPhoto;
        vars.avatarID   = this.avatarID;
        vars.fullName   = this.fullName; 
    }

    public async change( vars: any ) : Promise <any>
    {
        vars.avatarID = this.avatarID;

        this.fill( vars );
        
        return this.conquer.do( ACTIONS.AVATAR_CHANGE, vars );
    }

}

export default AvatarInstance;